import {
    PururinUpload
} from './vendor/pururn-upload-helper.js';

require('./vendor/form-tags')

var PururinUploadJs = {
    apiURL: 'https://i.pururin.me/upload',
    init: function () {
        var self = this;
        $('.new-gallery').on('click', function (e) {
            e.preventDefault();
            self.newGallery();
            $('.upload-options').addClass('d-none');
            $('#uploadForms').removeClass('d-none');
        });
        $('.replace-gallery').on('click', function (e) {
            e.preventDefault();
            self.replaceGallery();
            $('.upload-options').addClass('d-none');
            $('#replaceForm').removeClass('d-none');
        });
        // Alert closeable
        $('div[role="alert"] button').on('click', function (e) {
            $(e.target.parentNode).addClass('d-none');
        });
    },
    newGallery: function () {
        var self = this;
        var errTimeout = null;
        var pururinUpload = null;
        var file = null;
        // Upload when file submited
        $('#uploadForms input[name="file"]').on('change', function (e) {
            // Disable file input
            this.disabled = true;
            // Get file input
            file = this.files[0];
            if (!file) {
                PururinMessage.error('File input is required');
                this.disabled = false;
                return
            }
            // Create pururin upload instace
            pururinUpload = new PururinUpload(file, self.apiURL);
            // Run upload
            pururinUpload.Run();
            // Display laoder
            $('#loader').removeClass('invisible');
            $('#loader').addClass('visible');
            // Get progress
            pururinUpload.on('progress', (data) => {
                $('#loader span').text(`Uploading images.. ${data.totalUploaded}/${data.totalImages}`)
            });
            // Get progress
            pururinUpload.on('success', (data) => {
                // Enable upload button
                $('#uploadBtn').removeAttr('disabled');
                $('#loader').addClass('invisible');
                $('#success').removeClass('d-none');
                $('#success span').text('All images has been uploaded, please click the upload button to continue. Thank you for your contribution. We love you :)');
            })
            pururinUpload.on('error', (e) => {
                //Enable file input
                this.disabled = false;
                // Display error
                $('#loader').removeClass('visible');
                $('#loader').addClass('invisible');
                clearTimeout(errTimeout);
                errTimeout = setTimeout(() => {
                    PururinMessage.error(e.message);
                }, 300);
            })
        });
        // Next Button
        $('#nextBtn').on('click', function (e) {
            $('#uploadForms').carousel('next')
        });
        // Prev Button
        $('#prevBtn').on('click', function (e) {
            $('#uploadForms').carousel('prev')
        });
        // Upload Button
        $('#uploadBtn').on('click', function (e) {
            // Check required inputs
            if ($('input[name="english"]').val().length === 0) {
                PururinMessage.error('English field is required.');
                return;
            }
            if ($('select[name="language"]').val().length === 0) {
                PururinMessage.error('Language field is required.');
                return;
            }
            // Disable the button
            this.disabled = true;
            // Do request
            axios.post('/contribute/upload', {
                english: $('input[name="english"]').val(),
                japanese: $('input[name="japanese"]').val(),
                alternative_names: $('input[name="alternative_names"]').val(),
                description: $('textarea[name="description"]').val(),
                language: JSON.parse($('select[name="language"]').val()),
                category: JSON.parse($('select[name="category"]').val()),
                source: $('#uploadForms input[name="source"]').val(),
                artist_tags: JSON.parse($('input[name="artist_tags"]').val()),
                circle_tags: JSON.parse($('input[name="circle_tags"]').val()),
                parody_tags: JSON.parse($('input[name="parody_tags"]').val()),
                content_tags: JSON.parse($('input[name="content_tags"]').val()),
                character_tags: JSON.parse($('input[name="character_tags"]').val()),
                scanlator_tags: JSON.parse($('input[name="scanlator_tags"]').val()),
                convention_tags: JSON.parse($('input[name="convention_tags"]').val()),
                collection_tags: JSON.parse($('input[name="collection_tags"]').val()),
                collection_chapter: JSON.parse($('input[name="collection_chapter"]').val()),
                note: $('#uploadForms textarea[name="note"]').val(),
                image_data: pururinUpload.getImagePathData(),
                file_data: {
                    name: file.name,
                    size: file.size,
                    contents: pururinUpload.getFilesInfo(),
                },
                total_pages: pururinUpload.getTotal(),
            }).then((resp) => {
                $('#success').removeClass('d-none');
                $('#success span').text('Thank you for your contribution... You are currently being redirected to your contribution.');
                window.location.href = resp.data.redirect_url;
            }).catch(e => {
                PururinMessage.error(e.response.data.msg || e.response.data.message || e.message);
                this.disabled = false;
            })
        })
        // Check Button
        $('#checkBtn').on('click', function (e) {
            // Check required inputs
            if ($('input[name="english"]').val().length === 0) {
                PururinMessage.error('English field is required.');
                return;
            }
            if ($('select[name="language"]').val().length === 0) {
                PururinMessage.error('Language field is required.');
                return;
            }
            this.disabled = true;
            axios.post('/api/upload/check', {
                english: $('input[name="english"]').val(),
                language: JSON.parse($('select[name="language"]').val()),
            }).then((data) => {
                this.disabled = false;
                PururinMessage.error('No duplicate(s) found');
            }).catch((e) => {
                $('#success').addClass('d-none');
                if (e.response.status === 409) {
                    PururinMessage.error(`A duplicate found: <a href="${e.response.data.url}" target="_blank">${e.response.data.title}</a>`);
                } else {
                    PururinMessage.error(e.message);
                }
                this.disabled = false;
            })
        });
        // Import
        $('#uploadForms input[name="source"]').on('keyup', function (e) {
            if ($(this).val().length == 0) {
                $('#importBtn').attr('disabled', 'disabled');
            } else {
                $('#importBtn').removeAttr('disabled');
            }
        })
        $('#importBtn').on('click', function (e) {
            // Get curren source value
            var source = $('input[name="source"]').val();
            if (source.length == 0) {
                PururinMessage.error('Source input is required');
                return;
            }
            // Update html
            this.disabled = true;
            $(this).html('<i class="fas fa-spinner fa-spin"></i>');
            // Do request
            axios.post('/api/import/metadata', {
                source: source
            }).then((resp) => {
                $('input[name="english"]').val(resp.data.english)
                $('input[name="japanese"]').val(resp.data.japanese)
                $('input[name="alternative_names"]').val(resp.data.alternative_names)
                for (const type of tagTypes) {
                    if (!resp.data.tags[type]) continue;
                    $('input[name="' + type + '_tags"]').trigger('importChange', {
                        value: resp.data.tags[type],
                    });
                }
                if (resp.data.tags['language']) {
                    for (const language of resp.data.tags['language']) {
                        if (!language.id) continue;
                        $('select[name="language"]').val(JSON.stringify(language));
                    }
                }
                if (resp.data.tags['category']) {
                    for (const category of resp.data.tags['category']) {
                        if (!category.id) continue;
                        $('select[name="category"]').val(JSON.stringify(category));
                    }
                }
                // Update html button
                this.disabled = false;
                $(this).html('<i class="fas fa-file-import"></i>');

            }).catch((e) => {
                console.log(e);
                this.disabled = false;
                $(this).html('<i class="fas fa-file-import"></i>');
                PururinMessage.error(`Unable to get the metadata from ${source}`);
            });
        });
    },
    replaceGallery: function () {
        var self = this;
        var pururinUpload = null;
        var file = null;
        var errTimeout = false;
        // Upload when file submited
        $('#replaceForm input[name="file"]').on('change', function (e) {
            // Disable file input
            this.disabled = true;
            // Get file input
            file = this.files[0];
            if (!file) {
                PururinMessage.error('File input is required');
                this.disabled = false;
                return
            }
            // Create pururin upload instace
            pururinUpload = new PururinUpload(file, self.apiURL);
            // Run upload
            pururinUpload.Run();
            // Display laoder
            $('#loader').removeClass('invisible');
            $('#loader').addClass('visible');
            // Get progress
            pururinUpload.on('progress', (data) => {
                $('#loader span').text(`Uploading images.. ${data.totalUploaded}/${data.totalImages}`)
            });
            // Get progress
            pururinUpload.on('success', (data) => {
                // Enable upload button
                $('#uploadReplaceBtn').removeAttr('disabled');
                $('#loader').addClass('invisible');
                $('#success').removeClass('d-none');
                $('#success span').text('All images has been uploaded, please click the upload button to continue. Thank you for your contribution. We love you :)');
            })
            pururinUpload.on('error', (e) => {
                //Enable file input
                this.disabled = false;
                // Display error
                $('#loader').removeClass('visible');
                $('#loader').addClass('invisible');
                clearTimeout(errTimeout);
                errTimeout = setTimeout(() => {
                    PururinMessage.error(e.message);
                }, 300);
            })
        })

        // Replace Gallery Upload Button
        $('#uploadReplaceBtn').on('click', function (e) {
            this.disabled = true;
            axios.patch('/contribute/upload', {
                gid: $('input[name="gid"]').val(),
                source: $('#replaceForm input[name="source"]').val(),
                note: $('#replaceForm textarea[name="note"]').val(),
                image_data: pururinUpload.getImagePathData(),
                file_data: {
                    name: file.name,
                    size: file.size,
                    contents: pururinUpload.getFilesInfo(),
                },
                total_pages: pururinUpload.getTotal(),
            }).then((resp) => {
                $('#success').removeClass('d-none');
                $('#success span').text('Thank you for your contribution... You are currently being redirected to your contribution.');
                window.location.href = resp.data.redirect_url;
            }).catch(e => {
                PururinMessage.error(e.response.data.msg || e.response.data.message || e.message);
                this.disabled = false;
            })
        });
    },
}

$(function () {
    PururinUploadJs.init();
});
